import { cn } from '../lib/utils';

/* The wordmark: "inny" in the display face, the dot of the i replaced by the
   inbound arrow, the same green as the bot's visor. Sized in em so it scales
   with the font size it is given. */
export default function InnyWordmark({ size = 30, className }) {
  return (
    <span
      role="img"
      aria-label="Inny"
      className={cn('font-cond relative inline-block font-bold leading-none tracking-tight text-ink', className)}
      style={{ fontSize: size }}
    >
      <span aria-hidden="true">ınny</span>
      <svg aria-hidden="true" viewBox="0 0 10 12" className="absolute" style={{ left: '0.02em', top: '0.06em', width: '0.26em', height: '0.31em' }}>
        <rect x="3" y="0" width="4" height="6.5" rx="1.3" fill="#20885C" />
        <polygon points="0,5.5 10,5.5 5,11.5" fill="#20885C" />
      </svg>
    </span>
  );
}
